// @flow
import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'

export default function NotFound () {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      not found
    </div>
  )
}


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))